import AxiosInstance from '../axios/AxiosInstance';

export const contractService = {
  // Récupérer tous les contrats (pour admin)
  async getAllContracts() {
    try {
      const response = await AxiosInstance.get('/pld-contract');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contrats:', error);
      throw error;
    }
  },

  // Récupérer les contrats d'un client (basé sur le PLD du client connecté)
  async getClientContracts() {
    try {
      console.log('Appel API pour récupérer les contrats client...');
      const response = await AxiosInstance.get('/pld-contract/client-contracts');
      console.log('Réponse API contrats:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contrats client:', error);
      console.error('Status:', error.response?.status);
      console.error('Message:', error.response?.data);
      throw error;
    }
  },

  // Récupérer un contrat par ID
  async getContractById(contractId) {
    try {
      const response = await AxiosInstance.get(`/pld-contract/${contractId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du contrat:', error);
      throw error;
    }
  },

  // Générer un code de signature
  async generateSignatureCode(contractIds) {
    try {
      console.log('Génération du code pour les contrats:', contractIds);
      const response = await AxiosInstance.post('/pld-contract/generate-code', {
        pldContractsIds: contractIds
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la génération du code de signature:', error);
      throw error;
    }
  },

  // Signer un contrat
  async signContract(contractIds, validateCode) {
    try {
      console.log('Signature des contrats:', contractIds, 'avec le code:', validateCode);
      const response = await AxiosInstance.post('/pld-contract/sign', {
        pldContractIds: contractIds,
        validateCode: validateCode
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la signature du contrat:', error);
      throw error;
    }
  },

  // Télécharger un contrat
  async downloadContract(contractId,contractNumber) {
    try {
      const response = await AxiosInstance.get(`/pld-contract/download/${contractId}`, {
        responseType: 'blob'
      });

      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `contrat_${contractNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      console.error('Erreur lors du téléchargement du contrat:', error);
      throw error;
    }
  },

  // Obtenir l'URL pour voir un contrat
  async getContractViewUrl(contractId) {
    try {
      // Créer une URL temporaire pour visualiser le contrat
      const response = await AxiosInstance.get(`/pld-contract/view/${contractId}`, {
        responseType: 'blob'
      });

      // Créer une URL blob pour ouvrir le PDF dans un nouvel onglet
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      return url;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'URL du contrat:', error);
      throw error;
    }
  },

  // Relancer la signature d'un contrat
  async sendSignatureReminder(contractId) {
    try {
      const response = await AxiosInstance.get(`/pld-contract/relance-signature/${contractId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la relance:', error);
      throw error;
    }
  },

  // Récupérer la signature de l'agence (chargé à la demande)
  async getAgencySignature() {
    try {
      const response = await AxiosInstance.get('/pld-contract/agency-signature');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la signature:', error);
      throw error;
    }
  },

  // Récupérer les contrats par semaine et client pour le planning
  async getContractsByWeek(startDate, endDate) {
    try {
      const response = await AxiosInstance.get('/pld-contract/planning/week', {
        params: {
          startDate: startDate.toISOString().split('T')[0],
          endDate: endDate.toISOString().split('T')[0]
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contrats de la semaine:', error);
      throw error;
    }
  }
};

export default contractService;
